import prodContent from './content.production';

export default prodContent;
